import { useContext, useEffect } from 'react';
import { NavBarContext } from '@bumble/app/components/NavBar';

export default function useHideNavBarContent({ hide = true } = {}) {
  const { hideNavContent } = useContext(NavBarContext);
  useEffect(() => (hide ? hideNavContent() : () => null), [hide, hideNavContent]);
}
